/** Example IMOs for the free ship check — verified (2026-07-13) to resolve
 *  richly against the live register: found, real photo, risk profile with
 *  factors. Shared by the landing hero and /check so both stay in step;
 *  re-verify against the live endpoint before swapping entries. */
export const SHIP_CHECK_SAMPLES = [
  { imo: '9481233', label: 'NAVIOS BUENA VENTURA · bulk' },
  { imo: '9755933', label: 'MSC DIANA · container' },
  { imo: '9479852', label: 'COSTA FAVOLOSA · cruise' },
] as const;
